module.exports = __webpack_public_path__ + "static/media/glob.ac4cfbd0.png";